<template>
  <b-dropdown
    right
    variant="secondary"
    v-b-tooltip.hover
    title="Directe downloads"
    @click="() => {}"
  >
    <template #button-content>
      <font-awesome-icon icon="download" />
    </template>
    
    <b-dropdown-group header="PDF rapport">
      <b-dropdown-form style="width: 350px;">
        <b-checkbox 
          v-model="toonLogo" 
          class="my-3"
        >
          Met logo
        </b-checkbox>
      
        <b-form-group label="Kies bladen">
          <pdf-sheets 
            key="unitSheets" 
            v-model="geselecteerdebladen"
          />
        </b-form-group>

        <b-button 
          variant="primary" 
          class="my-3" 
          @click="onClick"
        >
          Exporteer <i class="fa fa-file-pdf-o" />
        </b-button>
      </b-dropdown-form>
    </b-dropdown-group>
    
    <b-dropdown-group header="Excel bestanden">
      <b-dropdown-item-button @click="() => downloadExcel('transplan')">
        Transplan <font-awesome-icon icon="file-excel" />
      </b-dropdown-item-button>
      <b-dropdown-item-button @click="() => downloadExcel('oprognose')">
        Oprognose <font-awesome-icon icon="file-excel" />
      </b-dropdown-item-button>
    </b-dropdown-group>
  </b-dropdown>
</template>
<script>
import { pdfBladenMixin } from '@/mixins/pdfBladenMixin';
import { serviceMixin } from "@/mixins/serviceMixin";
import { saveAs } from "file-saver";
import  PdfSheets from "@/components/PDFSheets";
import FontAwesome from '../icons/FontAwesome.vue';
export default {
  name: "ExportButtonUnit",
  components: {
    PdfSheets,
    FontAwesome
  },
  mixins: [pdfBladenMixin, serviceMixin ],
  props: {
    filename: {
      type: String,
      default: 'Rapport'
    }
  },
  data() {
    return {
      geselecteerdebladen: ["voorblad","inventarisatie","inspectie","prognose10","onderhoud","fotos"],
      toonLogo: true,
      bladen: [
        { text: "Voorblad", value: "voorblad" },
        { text: "Unitgegevens", value: "inventarisatie" },
        { text: "Inspectieresultaten", value: "inspectie" },
        { text: "Inspectieresultaten NEN 2767", value: "inspectieNEN" },
        { text: "Historie -3 tot 6 jaar", value: "historie" },
        { text: "Prognose 0 tot 9 jaar", value: "prognose10" },
        { text: "Prognose 10 tot 19 jaar", value: "prognose20" },
        { text: "Prognose 20 tot 29 jaar", value: "prognose30" },
        { text: "Gebreken", value: "gebreken" },
        //{ text: "Gebreken opgelost", value: "gebreken" },
        { text: "Onderhoud", value: "onderhoud" },
        { text: "Foto's", value: "fotos" }
      ]
    };
  },
  computed: {
    fullfilename: function() {
      return this.filename + '.pdf';
    },
    oprognosename: function() {
      return this.filename + '-oprognose.xlsx';
    },
  },
  methods: {
    onClick() {
      var vm = this;
      console.dir(this.getOrderedSheets(this.geselecteerdebladen));
      this.$http
        .post(
          "/unit/" + this.$route.params.id + "/pdf",
          { gekozenbladen: this.getOrderedSheets(this.geselecteerdebladen), logo: this.toonLogo },
          { responseType: "arraybuffer" }
        )
        .then(function(response) {
          var blob = new Blob([response.data], { type: "application/pdf" });
          saveAs(blob, vm.fullfilename);
        })
        .catch(function(error) {
          console.log(error);
        })
        .then(function() {
          //vm.isBusy = false;
        });
      return;
    },
    downloadExcel(type) {
      var vm = this;
      var endpoint = `/unit/${this.$route.params.id}/export/${type}/excel`;
      this.getBlob(endpoint).then(function(resp) {
        console.log(resp);
        var blob = new Blob([resp.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
          });
          saveAs(blob, vm.oprognosename);
      })
      .catch(function(error) {
        console.log(error)
      })
    },
  },
};
</script>